// パスワード変更促進画面で「今は変更しない」を押した職員に、一定期間この画面を再表示しないための記録。
// 共用PCでも職員ごとに判定できるよう、キーに職員IDを含めて localStorage に保存する。
// 別端末・別ブラウザでは再表示されるが、厳密な制御は不要なため許容している。

const KEY_PREFIX = 'codmon_manager_pws_';

/**
 * 再表示しない期間。0 にすると毎回表示される。
 * Safari は JS で書いたデータをサイトを 7 日間使わないと削除するため、7 日を超えると期間より早く再表示されうる
 */
export const SUPPRESS_DAYS = 3;

const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const SUPPRESS_DURATION_MS = SUPPRESS_DAYS * ONE_DAY_MS;

const storageKey = (administratorId: number | string): string => KEY_PREFIX + administratorId;

const isExpired = (value: string | null, now: number): boolean => {
  const skippedAt = Number(value);
  return !Number.isFinite(skippedAt) || skippedAt > now || now - skippedAt >= SUPPRESS_DURATION_MS;
};

const removeExpiredEntries = (now: number): void => {
  const keys = Object.keys(localStorage).filter((key) => key.startsWith(KEY_PREFIX));
  keys.forEach((key) => {
    if (isExpired(localStorage.getItem(key), now)) {
      localStorage.removeItem(key);
    }
  });
};

/** 「今は変更しない」を押したことを記録する */
export const suppressPasswordChangeRequired = (administratorId: number | string, now: number = Date.now()): void => {
  try {
    localStorage.setItem(storageKey(administratorId), String(now));
  } catch (e) {
    // 容量超過などで記録できなくても次回また促進画面が出るだけのため、例外で画面遷移を止めない
  }
};

/** 促進画面の再表示を抑止中か判定する。判定のついでに期限切れの記録を削除する */
export const isPasswordChangeRequiredSuppressed = (
  administratorId: number | string,
  now: number = Date.now()
): boolean => {
  try {
    removeExpiredEntries(now);
    return localStorage.getItem(storageKey(administratorId)) !== null;
  } catch (e) {
    return false;
  }
};
